



import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FavoriteViewModel, FavoriteService } from '../../api/favorite';
import { Message } from 'element-ui';

@Component({})
export default class FavoriteButton extends Vue {
  @Prop() private sourceId!: string;
  @Prop() private sourceType!: number;
  @Prop() private size: string = '';

  private favoriteService: FavoriteService = new FavoriteService();
  private isFavorite: boolean = false;

  @Watch('sourceId')
  private sourceId_OnChange(val: any, oldVal: any) {
    this.loadFavoriteState();
  }


  private mounted() {
    this.loadFavoriteState();
  }

  private loadFavoriteState() {
    if (this.sourceId !== '') {
      this.favoriteService.IsFavorited(this.sourceId, this.sourceType).then((response: any) => {
        this.isFavorite = response;
      });
    }
  }

  private btnFavorite_OnClick() {
    const favorite = this.favoriteService.NewModel;
    favorite.sourceID = this.sourceId;
    favorite.sourceType = this.sourceType;
    this.favoriteService.Create(favorite).then((response: any) => {
      console.log(response);
      this.isFavorite = response.id > 0;
      Message.success((this.isFavorite ? '收藏' : '取消收藏') + '成功！');
    });
  }
}
